/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import { HeaderLogo } from "./header-logo";

const MinimalHeader = () => {

    return (
        <div className='header'>
            <div className='header-content'>
                <HeaderLogo alt='nsbylaw-logo' />
            </div>
        </div>
    );
};

export { MinimalHeader };
